import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/person_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-98a431b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "dropdown user-menu",
  "data-bs-auto-close": "outside"
}
const _hoisted_2 = {
  type: "button",
  class: "btn btn-inline dropdown-toggle",
  id: "userDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_3 = {
  key: 0,
  class: "badge test-user"
}
const _hoisted_4 = {
  key: 1,
  class: "badge admin-user"
}
const _hoisted_5 = {
  key: 2,
  class: "badge impersonated"
}
const _hoisted_6 = {
  key: 3,
  class: "badge demo-user"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "user-icon"
}, null, -1))
const _hoisted_8 = { class: "user-name" }
const _hoisted_9 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "userDropdown"
}
const _hoisted_10 = { class: "hide-md" }
const _hoisted_11 = { class: "dropdown-item disabled user-name" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "user-icon"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "hide-md" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_15 = {
  key: 0,
  class: "badge notify-badge rounded-pill"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "dropdown-header"
}
const _hoisted_21 = { key: 3 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 5 }
const _hoisted_26 = { key: 6 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_28 = { key: 7 }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { key: 8 }
const _hoisted_31 = { key: 9 }

import { computed } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import { useUserSupervisorStore } from '@/gp/UserSupervisorStore'
import { useFamilyGroupInviteStore } from '@/gp/FamilyGroupInviteStore'
import { LoadMode } from '@/util/AsyncData'
import { useTokenManager, UserPrivilege } from '@/auth/TokenManager'
import { User } from '@/gp/GroupAdminModel'
import { Environment } from '@/util/Environment'
import { InvitationResult } from '@/gp/GroupAdminModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserMenu',
  setup(__props) {

const userStore = useUserStore()
const userSupervisorStore = useUserSupervisorStore()
const inviteStore = useFamilyGroupInviteStore()
const tokenManager = useTokenManager()

const userRef = computed(() => userStore.getAsyncSelf(LoadMode.EnsureLoaded)?.data)
const supervisedUsersRef = computed(() => {
  if (tokenManager.current.isSupervised)
    return [] // can't supervise others, and API call is forbidden anyway
  const sups = userSupervisorStore.getForSupervisor(tokenManager.current.userId, LoadMode.EnsureLoaded)
  return userStore.getLoadedUserList(sups.map(s => s.forUserId!))
})

const showRefreshTokenRef = computed(() => Environment.isDevelopment())
const showRevertRef = computed(() => {
  // TODO: allow reverting from supervised account if original was admin (not just supervisor)
  return tokenManager.current.actorId && !tokenManager.current.isSupervised
})

const pendingInvitesRef = computed(() => inviteStore.getInvitesForUser(undefined, LoadMode.EnsureLoaded)
  .filter(inv => inv.result == InvitationResult.Pending))

const notificationCountRef = computed(() => pendingInvitesRef.value.length)

async function onRefreshToken() {
  await tokenManager.refreshAsync()
}

function onRevert() {
  tokenManager.revert()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, [
      (userRef.value?.isTestUser)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Test "))
        : _createCommentVNode("", true),
      (_unref(tokenManager).current.isPrivilegedUser)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Admin "))
        : _createCommentVNode("", true),
      (_unref(tokenManager).current.actorId)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Acting "))
        : _createCommentVNode("", true),
      (_unref(tokenManager).current.userPrivileges.includes(_unref(UserPrivilege).DemoUser))
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Demo "))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createElementVNode("span", _hoisted_8, _toDisplayString(userRef.value?.displayName), 1)
    ]),
    _createElementVNode("ul", _hoisted_9, [
      _createElementVNode("li", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString(userRef.value?.displayName), 1)
        ])
      ]),
      _hoisted_13,
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "dropdown-item",
          to: "/account"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Account ")
          ]),
          _: 1
        })
      ]),
      _hoisted_14,
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "dropdown-item",
          to: "/trees"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Trees")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          class: "dropdown-item",
          to: "/groups"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Groups "),
            (notificationCountRef.value > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(notificationCountRef.value), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      (!_unref(tokenManager).current.isSupervised)
        ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
            _createVNode(_component_router_link, {
              class: "dropdown-item",
              to: "/profiles"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Managed profiles ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (supervisedUsersRef.value.length > 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_17, _hoisted_19))
        : _createCommentVNode("", true),
      (supervisedUsersRef.value.length > 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_20, " Supervised users "))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supervisedUsersRef.value, (su) => {
        return (_openBlock(), _createElementBlock("li", {
          key: su.id,
          class: ""
        }, [
          _createVNode(_component_router_link, {
            class: "dropdown-item",
            to: _unref(User).getPageUrl(su.id)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(su.displayName), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128)),
      (_unref(tokenManager).current.isPrivilegedUser)
        ? (_openBlock(), _createElementBlock("li", _hoisted_21, _hoisted_23))
        : _createCommentVNode("", true),
      (_unref(tokenManager).current.canReadUsers)
        ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
            _createVNode(_component_router_link, {
              class: "dropdown-item admin",
              to: "/admin"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Admin")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(tokenManager).current.canReadUsers)
        ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
            _createVNode(_component_router_link, {
              class: "dropdown-item admin",
              to: "/admin/users"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Manage users")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(tokenManager).current.canReadUsers)
        ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
            _createVNode(_component_router_link, {
              class: "dropdown-item admin",
              to: "/admin/identities"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Manage identities")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_27,
      (showRefreshTokenRef.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
            _createElementVNode("button", {
              type: "button",
              class: "dropdown-item dev-only",
              disabled: !_unref(tokenManager).current.canRefresh,
              onClick: onRefreshToken
            }, " Refresh access token ", 8, _hoisted_29)
          ]))
        : _createCommentVNode("", true),
      (showRevertRef.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
            _createElementVNode("button", {
              type: "button",
              class: "dropdown-item admin",
              onClick: onRevert
            }, " Revert to original user ")
          ]))
        : (_openBlock(), _createElementBlock("li", _hoisted_31, [
            _createVNode(_component_router_link, {
              class: "dropdown-item",
              to: "/signout"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Sign out ")
              ]),
              _: 1
            })
          ]))
    ])
  ]))
}
}

})